import React from "react";
import { VStack } from "@UI/Components/Stack/Stack";
import { Spinner } from "@UI/Components/Spinner/Spinner";
import {
  ICandidate,
  ICandidateCardProps,
  ICandidateOfferModalProps,
} from "../../types";
import { CandidateCard } from "./CandidateCard";

interface CandidateListSectionProps {
  candidates: ICandidate[];
  isLoading: boolean;
  emptyPlaceholder: React.ReactNode;
  onCandidateOfferModalOpen: ICandidateCardProps["onCandidateOfferModalOpen"];
  removeUnreadIndicatorFromConversation: ICandidateCardProps["removeUnreadIndicatorFromConversation"];
  onDeclineOfferModalOpen: ICandidateOfferModalProps["onDeclineOfferModalOpen"];
}

export const CandidateListSection: React.FC<CandidateListSectionProps> = ({
  candidates,
  isLoading,
  emptyPlaceholder,
  onCandidateOfferModalOpen,
  removeUnreadIndicatorFromConversation,
  onDeclineOfferModalOpen,
}) => {
  return (
    <VStack w="full" alignItems="center" spacing="0">
      {isLoading ? (
        <VStack w="full" justifyContent="center" py="30px">
          <Spinner color="gray.500" size="md" />
        </VStack>
      ) : candidates.length > 0 ? (
        <VStack w="full" spacing="16px" alignItems="center">
          {candidates.map((item, index) => (
            <CandidateCard
              onCandidateOfferModalOpen={onCandidateOfferModalOpen}
              removeUnreadIndicatorFromConversation={
                removeUnreadIndicatorFromConversation
              }
              onDeclineOfferModalOpen={onDeclineOfferModalOpen}
              key={`${item?.id}-${index}`}
              {...item}
            />
          ))}
        </VStack>
      ) : (
        emptyPlaceholder
      )}
    </VStack>
  );
};
